import React from "react";
import { IoLocationSharp } from "react-icons/io5";
import { FaUser } from "react-icons/fa";
import { renderPrice, timeSince } from "../../../Utils/functions";
import Loading from "../../Loading";
const RecentProductCard = ({ loading, data = {} }) => {
  const render = () => {
    if (data.price) {
      if (data.price == "0") {
        return "قیمت : به صورت توافقی";
      } else {
        return `قیمت : ${renderPrice(data.price)}`;
      }
    }
    return "قیمت : به صورت توافقی";
  };
  if (loading) {
    return <Loading height={"360px"} />;
  }
  return (
    <div className="recent-product">
      <div className="content-recent-product">
        <h6 style={{ paddingBottom: "5px" }}>{`${data?.title ?? ""}`}</h6>
        <div>
          <div className="icon-label  mb-7">
            <IoLocationSharp />
            <p>{`${data?.province?.title ?? ""}، ${
              data?.city?.title ?? ""
            }`}</p>
          </div>
          <div className="icon-label  ">
            <FaUser />
            <p>{data?.contacts_data?.fullname || data?.contacts_data?.co_name || data?.client?.fullname}</p>
          </div>
        </div>
      </div>
      <div className="img-recent-product">
        <img
          src={data?.main_image?.url || require("../../../Assets/images/1.png")}
          alt={data?.main_image?.alt || data.title}
        />
      </div>
    </div>
  );
};

export default RecentProductCard;
